import React, { Fragment, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";
import Select from "../ReactSelect";
import { storeSelectedProgrammeDetails } from "../../actions/reports";

import fadeInUp from "../../helpers/Animations";

/*
 * Dropdown for selecting the programme.
 * Fetches a list of reports, displays a dropdown and updates the store with a programe ID for the selected programme.
 * If there is only one programme in the list it will set the ID for that programmes as the selected ID and display nothing.
 */

const renderDropdownArrow = ({ isOpen }) => {
  const MdArrow = isOpen ? MdKeyboardArrowUp : MdKeyboardArrowDown;
  const blueClass = isOpen ? "" : " blue";
  return (
    <MdArrow className={`Select__arrow position__center--right${blueClass}`} />
  );
};

renderDropdownArrow.defaultProps = {
  isOpen: false,
};

renderDropdownArrow.propTypes = {
  isOpen: PropTypes.bool,
};

const ReportSelect = ({ reports, selected, setProgrammeDetails }) => {
  const setSelectedProgramme = useCallback(
    (programmeID) => {
      const selectedProgramme = reports.find(
        (report) => String(report.code) === String(programmeID)
      );
      if (selectedProgramme) {
        setProgrammeDetails(selectedProgramme);
      }
    },
    [reports, setProgrammeDetails]
  );

  useEffect(() => {
    if (reports.length === 1) {
      setSelectedProgramme(reports[0].code);
    }
  }, [reports, setSelectedProgramme]);

  const handleChange = ({ value }) => setSelectedProgramme(value);

  const options = reports.map((report) => ({
    label: report.name,
    value: report.code,
  }));

  return reports.length > 1 ? (
    <Fragment>
      <div className="programme-select">
        <label htmlFor="programme">
          <span className="label-text">Select Account:</span>
          <Select
            id="programme"
            name="programme"
            onChange={handleChange}
            value={reports.find((report) => report.code === selected)}
            options={options}
            arrowRenderer={renderDropdownArrow}
            className="Select"
          />
        </label>
        <p>
          <small>
            {" "}
            To give feedback on the Staff Reports feature or to report a bug,
            please email{" "}
            <a href="mailto:support@afes.org.au">support@afes.org.au</a>
          </small>
        </p>
      </div>
      <motion.hr animate={fadeInUp.animate} transition={fadeInUp.transition} />
    </Fragment>
  ) : null;
};

ReportSelect.defaultProps = {
  reports: [],
  selected: "",
};

ReportSelect.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.object),
  setProgrammeDetails: PropTypes.func.isRequired,
  selected: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  setProgrammeDetails: (programmeID) =>
    dispatch(storeSelectedProgrammeDetails(programmeID)),
});

const mapStateToProps = (state) => ({
  reports: state.session.userdata.reports,
  selected: state.reports.programme.program_id,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportSelect);
